import { modifyMegaMenuTreeData, modifyMenuTreeData } from "@/helpers/category";

export const appReducer = (state, action) => {
  switch (action.type) {
    case "get_ctree":
      return {
        ...state,
        categoryData: action?.payload,
        menuTreeData: modifyMenuTreeData(action?.payload?.children_data),
        megaMenuTreeData: modifyMegaMenuTreeData(
          action?.payload?.children_data
        ),
        cacheTime: action?.payload?.cacheTime, // 30 minutes in milliseconds
      };
    case "set_selc_ctree":
      return {
        ...state,
        selectedCategoryData: action?.payload,
      };
    case "set_region":
      return {
        ...state,
        regionId: action?.payload,
      };
    case "clear":
      return {
        categoryData: [],
        regionId: null,
      };
    default:
      return state;
  }
};
